module.exports = __webpack_public_path__ + "2acb60f2/img/saly-icon.39e12342.jpg";